import { Box, IconButton, TableCell, TableRow, Typography } from '@mui/material';
import QuantityHandle from './QuantityHandle';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import { handleAmount } from '../../../shared/extra';
import { removeAnDenomination } from '../../../store/productDetails/action';

const denominationTableStyles = {
  emptyMessageTypography: {
    fontSize: '1.125rem',
    fontWeight: 400,
    color: 'text.primary',
  },
  denominationRow: {
    backgroundColor: '#efefefff',
    '& td': {
      borderTop: 'none',
      borderBottom: 'none',
    },
    '& td:first-of-type': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& td:last-of-type': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
  },
  amountCell: {
    width: 100,
    py: 1.5,
    px: 1,
    border: 0,
    fontSize: { xs: '.7rem', sm: '.9rem', lg: '1rem' },
    color: 'textPrimary.main1',
    fontWeight: { xs: 700, sm: 700, lg: 700 },
  },
  discountCell: {
    py: 1.5,
    px: 1,
    width: 100,
    fontSize: { xs: '.7rem', sm: '.9rem', lg: '1rem' },
    color: 'textPrimary.main1',
    fontWeight: { xs: 700, sm: 700, lg: 700 },
    border: 'none',
  },
  quantityCell: {
    py: 1.5,
    px: 1,
    width: 100,
    border: 'none',
  },
  totalAmountCell: {
    width: 100,
    py: 1.5,
    px: 1,
    fontSize: { xs: '.7rem', sm: '.9rem', lg: '1rem' },
    color: 'textPrimary.main1',
    fontWeight: 700,
    border: 'none',
  },
  deleteButtonCell: {
    py: 1.5,
    px: 1,
    flex: 1,
    border: 'none',
  },
  deleteIconButton: {
    '&:hover': {
      backgroundColor: 'rgb(246 146 146 / 30%)',
    },
  },
};

function DenominationTable(props) {
  const { setSnackbar, handleClose } = props;
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const DENOMINATION_STORE_DATA = useSelector((state) => state.Denominations?.allData);
  const dispatch = useDispatch();

  if (DENOMINATION_STORE_DATA?.length === 0 && PRODUCTDETAILS.rangeDenomination) {
    return (
      <TableRow>
        <TableCell component="th" scope="row" align="center" colSpan={5}>
          <Typography variant="h6" sx={denominationTableStyles.emptyMessageTypography}>
            Enter the denomination amount
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {DENOMINATION_STORE_DATA?.map((data) => {
        return (
          <TableRow
            key={`product-denomination-${data.AMOUNT}`}
            sx={denominationTableStyles.denominationRow}
          >
            <TableCell
              align="center"
              sx={denominationTableStyles.amountCell}
            >
              {handleAmount(data.AMOUNT)}
            </TableCell>

            <TableCell
              align="center"
              sx={denominationTableStyles.discountCell}
            >
              {PRODUCTDETAILS.discount}%
            </TableCell>

            <TableCell align="center" sx={denominationTableStyles.quantityCell}>
              <Box className="product__denomination_table_quantity">
                <QuantityHandle
                  denominationData={data}
                  rangeDenomination={PRODUCTDETAILS.rangeDenomination}
                />
              </Box>
            </TableCell>

            <TableCell
              align="center"
              sx={denominationTableStyles.totalAmountCell}
            >
              {handleAmount(
                PRODUCTDETAILS.isCashbackProduct
                  ? data.AMOUNT * data.QUANTITY
                  : data.AMOUNT * data.QUANTITY -
                  (data.AMOUNT * data.QUANTITY * PRODUCTDETAILS.discount) / 100
              )}
            </TableCell>

            {PRODUCTDETAILS.rangeDenomination && (
              <TableCell
                align="center"
                sx={denominationTableStyles.deleteButtonCell}
              >
                <IconButton
                  onClick={() => removeDenoRow(data.AMOUNT)}
                  aria-label="delete-denomination-row"
                  color="error"
                  sx={denominationTableStyles.deleteIconButton}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </>
  );

  function removeDenoRow(amt) {
    setSnackbar({
      open: true,
      message: `₹${amt} Amount Denomination is Deleted!`,
    });

    setTimeout(() => {
      handleClose();
    }, 800);
    dispatch(removeAnDenomination(amt));
  }
}

export default DenominationTable;
